module.exports = __webpack_public_path__ + "static/tastyGravyProducts-feecc63bc672eb5dcdf1040e513009b9.jpg";